import React, { useEffect, useState } from 'react'
import styles from './Categories.module.css'
import { IoIosArrowDown, IoIosAdd, IoIosRemove } from "react-icons/io";
import { MdClose } from 'react-icons/md';
import IconComponent from '../../IconComponent/IconComponent';
import Portal from '../../Portal/Portal';
import axios from 'axios';

export type SubCategories = {
    ID: number;
    CategoryID: number;
    Name: string;
}

export type Categories = {
    ID: number;
    Name: string;
    Image: string;
}

export type CategoriesProps = {
    setFilterProduct: React.Dispatch<React.SetStateAction<number | null>>;
    filterProduct: number | null;
}

const Categories = (props: CategoriesProps) => {

    const [openMenu, setOpenMenu] = useState(false);
    const [subCategoriesMap, setSubCategoriesMap] = useState<Record<number, SubCategories[]>>({});
    const [categories, setCategories] = useState<Categories[]>([]);
    const [currentItem, setCurrentItem] = useState<number>(0);
    const [closingItem, setClosingItem] = useState<number | null>(null);
    const [currentCat, setCurrentCat] = useState<number>(0);
    const [currentSubName, setCurrentSubName] = useState<string>('');

    // Função para buscar subcategorias, com cache
    const fetchSubs = async (categoryId: number) => {
        if (subCategoriesMap[categoryId]) return; // Já carregado, não buscar
        try {
            const { data: subs } = await axios.get("https://sazuli.pt/api/subcategories", {
                params: { categoryId }
            });
            setSubCategoriesMap(prev => ({
                ...prev,
                [categoryId]: subs
            }));
        } catch (err) {
            console.error("Data fetch error:", err);
        }
    };

    // Fetch categories + encontrar categoria da filterProduct
    useEffect(() => {
        const fetchCategoriesAndFind = async () => {
            try {
                const { data: cats } = await axios.get('https://sazuli.pt/api/categories');
                setCategories(cats);

                if (props.filterProduct) {
                    for (const cat of cats) {
                        const { data: subs } = await axios.get('https://sazuli.pt/api/subcategories', {
                            params: { categoryId: cat.ID }
                        });
                        const match = subs.find((sub: SubCategories) => sub.ID === props.filterProduct);
                        if (match) {
                            setCurrentSubName(match.Name)
                            setCurrentCat(cat.ID);
                            setSubCategoriesMap(prev => ({
                                ...prev,
                                [cat.ID]: subs
                            }));
                            break;
                        }
                    }
                }
            } catch (err) {
                console.error("Error fetching categories or subcategories:", err);
            }
        };

        fetchCategoriesAndFind();
    }, [props.filterProduct]);

    // Quando currentItem muda, buscar subcategorias se necessário
    useEffect(() => {
        if (currentItem) {
            fetchSubs(currentItem);
        }
    }, [currentItem]);

    // Abrir automaticamente categoria quando currentCat muda
    useEffect(() => {
        if (currentCat) {
            setCurrentItem(currentCat);
        }
    }, [currentCat]);

    return (
        <div className={styles.container}>
            <div className={styles.topbar}>
                <div className={styles.title}>
                    <span className={styles.cat_title}>{categories.find(cat => cat.ID === currentItem)?.Name}</span>
                    <span className={styles.sub_title}>{currentSubName}</span>
                </div>
                <div className={styles.btn} onClick={() => setOpenMenu(!openMenu)}>
                    <span className={styles.btnContent}>
                        Categorias <IconComponent icon={IoIosArrowDown} size={20} />
                    </span>
                </div>
            </div>
            <Portal>
                <>
                    <div
                        className={`${styles.backdrop} ${openMenu ? styles.showBackdrop : styles.hideBackdrop}`}
                        onClick={() => setOpenMenu(false)}
                    />
                    <div className={`${styles.menu} ${openMenu ? styles.showMenu : styles.hideMenu}`}>
                        <div className={styles.header}>
                            <span className={styles.closeMenu} onClick={() => setOpenMenu(false)}>
                                <IconComponent icon={MdClose} size={30} />
                            </span>
                        </div>
                        <div className={styles.content}>
                            <div className={styles.item}>
                                <span className={styles.subtitle}>Menu</span>
                            </div>
                            <div className={styles.categoriesScroll}>
                                <div className={styles.categories}>
                                    {categories.map((category) => {
                                        const isActive = currentItem === category.ID;
                                        const isClosing = closingItem === category.ID;
                                        const subs = subCategoriesMap[category.ID] || [];
                                        return (
                                            <div
                                                className={styles.categorie}
                                                key={category.ID}
                                            >
                                                <div className={styles.titleCat} onClick={() => {
                                                    if (category.ID === currentItem) {
                                                        setClosingItem(category.ID);
                                                        setTimeout(() => {
                                                            setCurrentItem(0);
                                                            setClosingItem(null);
                                                        }, 400);
                                                    } else {
                                                        setCurrentItem(category.ID);
                                                        setClosingItem(null);
                                                        fetchSubs(category.ID);
                                                    }
                                                }}>
                                                    <span>
                                                        <IconComponent
                                                            icon={isActive ? IoIosRemove : IoIosAdd}
                                                            size={20}
                                                        />
                                                    </span>
                                                    <span>{category.Name}</span>
                                                </div>
                                                <div
                                                    className={`${styles.subCategoriesWrapper} ${isActive && !isClosing ? styles.show : ''
                                                        } ${isClosing ? styles.hide : ''}`}
                                                >
                                                    <div className={styles.subCategories}>
                                                        {subs.map((sub) => (
                                                            <span
                                                                key={sub.ID}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    props.setFilterProduct(sub.ID);
                                                                    setOpenMenu(false);
                                                                }}
                                                                className={`${props.filterProduct === sub.ID ? styles.active_s_c : ''}`}
                                                            >
                                                                {sub.Name}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </Portal>
        </div>
    )
}

export default Categories
